
/**
 * ...
 * @author fpinn
 * Please Note: The MINIMIZED_STATE is overloaded.
 *	 If -1, then not minimized
 *	 If not -1 (NOT_MINIMIZED) then it is the count of unread messages
 *	 So, if:
 *		-1 - Then not minimized
 *		 0 - Then minmized without any unread messages
 *		 1 - Then minimized with 1 unread message. (and so on)
 * I know, I know, we all hate magic numbers.
 * But it is internal to this module only and after all -1 is a magic number in indexOf method of String :)
 */
/**
 * package: com.inq.flash.client.control
 * class: MinimizeManager
 * root Object
 */

com.inq.flash.client.control.MinimizeManager = {};

/** @private @type {number} */
com.inq.flash.client.control.MinimizeManager.count = 0;
/** @type {boolean} */
com.inq.flash.client.control.MinimizeManager.minimized = false;
/** @type {boolean} */
com.inq.flash.client.control.MinimizeManager.onActionRestore = false;
/**
 * RTDEV-15508
 * Added to variable to prevent opener and transcript lines being read when the user moves to another link
 * while that chat is in minimizzed state.
 */
/** @type {boolean} */
com.inq.flash.client.control.MinimizeManager.restoreChatInProgress = false;

/**
 * RTDEV-16769
 */
/** @type {boolean} */
com.inq.flash.client.control.MinimizeManager.minimizedBySleep = false;

/**
 * onClose - restores the chat when agent disconnects
 * EXCEPT when we are doing psuedo-close and there is no thank-you page
 * Then we want to close (for real).
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function onClose():Void
 * @public
 * @static
 * @see ChatExitMessageHandler
 * @return {void}
 */
com.inq.flash.client.control.MinimizeManager.onClose = function() {
	if((com.inq.flash.client.control.PersistenceManager.GetValue(REALLY_MINIMIZED,com.inq.flash.client.control.MinimizeManager.count) == com.inq.flash.client.control.MinimizeManager.IS_MINIMIZED || com.inq.flash.client.control.MinimizeManager.btnRestore == null) && com.inq.flash.client.control.MinimizeManager.minimized) {
		/** @type {boolean} */
		var tY = com.inq.flash.client.control.FlashPeer.isThankYouEnabled();
		if(!tY) {
			com.inq.flash.client.chatskins.SkinControl.actionBtnCloseChat(null);
			return;
		}
	}
	com.inq.flash.client.control.MinimizeManager.Restore();
};


/**
 * lastAgentMessage - increments the "not seen" count and displays the message
 *
 * Revised for RTDEV-2355 - We should be able to restore even when we do not have an agent message
 * Therefor, we moved the restore from the test for agent message.
 * Also restores should be done after the count and message rendering stuff.
 *
 * $type TFun([{ name => agentMsg, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * static public function lastAgentMessage(agentMsg:String)
 * @public
 * @static
 * @see ChatCommunicationMessageHandler
 * @see ChatCobrowseMessageHandler
 * @see ChatCommandMessageHandler
 * @param {string}  agentMsg - , display the message from the agent
 * @return {void}
 */
com.inq.flash.client.control.MinimizeManager.lastAgentMessage = function(agentMsg) {
	if(agentMsg != null && agentMsg.length > 0 && com.inq.flash.client.control.MinimizeManager.isMinimized()) {
		com.inq.flash.client.control.MinimizeManager.count++;
		com.inq.flash.client.control.PersistenceManager.SetValue(MINIMIZED_COUNT,com.inq.flash.client.control.MinimizeManager.count);
		com.inq.flash.client.control.MinimizeManager.displayAgentMessageAndCount(agentMsg);
	}
	if(com.inq.flash.client.control.PersistenceManager.GetValue(REALLY_MINIMIZED,com.inq.flash.client.control.MinimizeManager.count) == com.inq.flash.client.control.MinimizeManager.IS_MINIMIZED || com.inq.flash.client.control.MinimizeManager.btnRestore == null) {
		com.inq.flash.client.control.MinimizeManager.Restore();
	}
};


/**
 * showCloseButton
 * Show the close button when minimize funcitonality is active
 * *
 * --------------------- *
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function showCloseButton()
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.control.MinimizeManager.showCloseButton = function() {
	/** @type {com.inq.ui.Button} */
	var btnClose = Application.application.getButton("btnCloseChat");
	if(btnClose != null) {
		btnClose.setVisible(true);
		if(null != com.inq.flash.client.control.MinimizeManager.btnReallyMinimized) com.inq.flash.client.control.MinimizeManager.btnReallyMinimized.setVisible(false);
		if(null != com.inq.flash.client.control.MinimizeManager.btnMinimize) {
			com.inq.flash.client.control.MinimizeManager.btnMinimize.setVisible(false);
			com.inq.flash.client.control.MinimizeManager.btnMinimize = null;
		}
	}
};


/**
 * displayAgentMessageAndCount
 *
 * Displays agent messages while chat is minimized, the objects are specified in skin file.
 *
 * @public
 * @static
 * @see    ChatCommunicationMessageHandler (called by)
 * @param {string}  agentMsg - , display the message from the agent, but do not touch the count
 * @return {void}
 */
com.inq.flash.client.control.MinimizeManager.displayAgentMessageAndCount = function(agentMsg) {
	if(agentMsg != null && agentMsg.length > 0 && com.inq.flash.client.control.MinimizeManager.isMinimized() && com.inq.flash.client.control.MinimizeManager.count > 0) {
		if (com.inq.utils.Capabilities.isIOSWebView()) {
			com.inq.flash.client.control.MinimizeManager.floatMinimized();
		}
		if(com.inq.flash.client.control.MinimizeManager.agentMsgCounter != null) {
			com.inq.flash.client.control.MinimizeManager.agentMsgCounter._setText("" + com.inq.flash.client.control.MinimizeManager.count);
			if (!com.inq.flash.client.control.MinimizeManager.agentMsgCounter._visible) {
				if (com.inq.utils.Capabilities.isAndroid()) {
					com.inq.flash.client.control.MinimizeManager.agentMsgCounter._div.style.opacity = 1;
				}
				com.inq.flash.client.control.MinimizeManager.agentMsgCounter.setVisible(true);
			}
		}

		if(com.inq.flash.client.control.MinimizeManager.agentText != null) {
			com.inq.flash.client.control.MinimizeManager.agentText._setText(agentMsg);
			if (!com.inq.flash.client.control.MinimizeManager.agentText._visible) {
			com.inq.flash.client.control.MinimizeManager.agentText.setVisible(true);
	}
		}
	}
};


/**
 * displaySmallScreenMsg
 * Display small screen warning message.
 *
 * $type TFun([],TEnum(Void,[]))
 * static private function displaySmallScreenMsg()
 * @private
 * @static
 * @return {void}
 */
com.inq.flash.client.control.MinimizeManager.displaySmallScreenMsg = function() {
	if (com.inq.utils.Capabilities.isPhone()) {
		// orientation does not exist in many desktop browsers.  So assume "Portrait" mode when no orientation facility exists
		/** @type {boolean} */
		var landscape = ("orientation" in window)
            ? !(window.parent.orientation == 0 || window.parent.orientation == 180)
            : false ;
		/*
		 * MOB-368: Mobile Chrome has a bug which causes it to initially
		 * report the orientation incorrectly.  We compensate for this by
		 * checking the height/width directly.
		 * Note: Fred says that this is not the full Fix.  The problem arizes on some Chrome browsers due to an error in detecting oreintation change.
		 *       This has been discovered in mobile Chrome in versions 33 through 35.  It is tasked to be fixed in version 36.
		 *       Please see: https://code.google.com/p/chromium/issues/detail?id=347507
		 *
		 * RTDEV-6776 change is because (orientation WORKS and screen size NOT WORKS) on Chrome earlier than version 33
		 *      ex) NEXUS 5 with Chrome 30.0.1599.105
		 */
		if (com.inq.utils.Capabilities.isChrome()) {
			/** @type {integer} */
			var bver = parseInt(window.navigator.appVersion.match(/Chrome\/(\d+)\./)[1], 10);
			/*
			 * MOB-730: Mobile chrome version 33 above until 35 is giving false value for screen.width and screen.height while changing the orientation.
			 * To fix this discrepancy I have used outerWidth and outerHeight to detect orientation.
			 * Chrome version prior to 33 have correct value from line #149. Hence we rely on that value to detect the orientation
			 */
			/** @type {Window}*/
			var tpwin = window.top;
			if ( isNaN(bver) ||  bver>=33 && bver<=35) {
				landscape = (tpwin.outerWidth > tpwin.outerHeight);
			}
			else if(bver>=36)
				landscape = (tpwin.screen.width > tpwin.screen.height);
		}
		com.inq.flash.client.control.MinimizeManager.onoffSmallScreenWarning(landscape && com.inq.flash.client.control.MinimizeManager.minimized == false);
	}
};


/**
 * Show or hide small screen warning message.
 *
 * @private
 * @static
 * @param {boolean} isOn visible or not state of smallScreenMsg image.
 * @return {void}
 */
com.inq.flash.client.control.MinimizeManager.onoffSmallScreenWarning = function(isOn) {
	/** @type {com.inq.ui.Canvas} */
	var can = Application.application.getCanvas("smallScreenMsg");
	/** @type {com.inq.ui.Button} button for set focus and hide keyboard if its active. */
	var button = Application.application.getButton("btnSmallScreen");
	if (!!can && !!button) {
		button.setAttribute("aria-label", "For better chat experience, please use portrait mode");
		can.setVisible(isOn);
		if (isOn) {
			button.getPrimaryObject().blur();
			button.setImageFocus();
		}
	}
};



// this doesnt need to be controled by init, it is specified in the mxml and stylesheets
// it could be called by restore and minimize probably

/**
 * initButtonVisibility
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function initButtonVisibility():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.control.MinimizeManager.initButtonVisibility = function () {
	if(!com.inq.flash.client.chatskins.SkinControl.getIsPersistentChat()) {
		if (com.inq.flash.client.control.MinimizeManager.btnReallyMinimized != null && com.inq.flash.client.control.MinimizeManager.btnReallyMinimized.getStyle("neverShow") != null
			&&com.inq.flash.client.control.MinimizeManager.btnReallyMinimized.getStyle("neverShow") == "true" && com.inq.flash.client.control.PersistenceManager.GetValue(REALLY_MINIMIZED, com.inq.flash.client.control.MinimizeManager.count) == com.inq.flash.client.control.MinimizeManager.SHOW_FAKE_MINIMIZE) {
			if (com.inq.flash.client.chatskins.SkinControl.isInApplication("btnCloseChat")) {
				var btnClose = Application.application.getButton("btnCloseChat");
				btnClose.setVisible(true)
			}
			com.inq.flash.client.control.MinimizeManager.btnReallyMinimized.setVisible(false)
		}
		else if (com.inq.flash.client.control.MinimizeManager.btnReallyMinimized != null && com.inq.flash.client.control.MinimizeManager.btnReallyMinimized.getStyle("neverShow") != null && com.inq.flash.client.control.MinimizeManager.btnReallyMinimized.getStyle("neverShow") == "false"
				&& com.inq.flash.client.control.PersistenceManager.GetValue(REALLY_MINIMIZED, com.inq.flash.client.control.MinimizeManager.count) == com.inq.flash.client.control.MinimizeManager.SHOW_FAKE_MINIMIZE) {
				com.inq.flash.client.control.MinimizeManager.btnReallyMinimized.setVisible(true)

		}

		if (com.inq.flash.client.control.MinimizeManager.btnReallyMinimized != null && com.inq.flash.client.control.PersistenceManager.GetValue(REALLY_MINIMIZED, com.inq.flash.client.control.MinimizeManager.count) != com.inq.flash.client.control.MinimizeManager.SHOW_FAKE_MINIMIZE  ) {
			if (com.inq.flash.client.chatskins.SkinControl.isInApplication("btnCloseChat")) {
				var btnClose = Application.application.getButton("btnCloseChat");
				btnClose.setVisible(false)
			}
		}
		else {
			var btnClose = Application.application.getButton("btnCloseChat");
			if (btnClose) {	// Button to close chat is not present on the all chat skins (f.e. Asus)
				btnClose.setVisible(true)
			}
		}
	} else {
		if(null != com.inq.flash.client.control.MinimizeManager.btnReallyMinimized) {
			com.inq.flash.client.control.MinimizeManager.btnReallyMinimized.setVisible(false)
		}else {
			if(null != com.inq.flash.client.control.MinimizeManager.btnMinimize) {
				com.inq.flash.client.control.MinimizeManager.btnMinimize.setVisible(false)
			}
		}
	}

};



/**
 * attachButtonHandlers
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function attachButtonHandlers():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.control.MinimizeManager.attachButtonHandlers = function () {
    var clientWin = window.parent;
    if (com.inq.flash.client.control.MinimizeManager.btnMinimize != null) {
        com.inq.flash.client.control.MinimizeManager.btnMinimize.addEventListener(com.inq.events.MouseEvent.CLICK, com.inq.flash.client.control.MinimizeManager.actionMinimize)
    }
    if (com.inq.flash.client.control.MinimizeManager.btnRestore != null) {
        com.inq.flash.client.control.MinimizeManager.btnRestore.addEventListener(com.inq.events.MouseEvent.CLICK, com.inq.flash.client.control.MinimizeManager.actionRestore)
    }

    if (!com.inq.utils.Capabilities.isAndroid()) {
        com.inq.utils.Capabilities.BindListener(clientWin, "scroll", com.inq.flash.client.control.MinimizeManager.floatMinimized);
        com.inq.utils.Capabilities.BindListener(clientWin, "resize", com.inq.flash.client.control.MinimizeManager.floatMinimized);
        com.inq.utils.Capabilities.BindListener(clientWin, "orientationchange", com.inq.flash.client.control.MinimizeManager.floatMinimized)
    }

      if (com.inq.flash.client.control.MinimizeManager.btnReallyMinimized != null) {
       com.inq.flash.client.control.MinimizeManager.btnReallyMinimized.addEventListener(com.inq.events.MouseEvent.CLICK, com.inq.flash.client.control.MinimizeManager.actionReallyMinimize)
     }

    // MOB-519 move  minimize/restore button above keyboard - for inputs on client page
    //( not needed on android because keyboard resizes layout instead of overlaying )
    if (com.inq.utils.Capabilities.isIphone()) {
        com.inq.flash.client.control.MinimizeManager.bindHandlerForClientInputFieldsIos();
    }
};

/**
 * restoreState
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function restoreState():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.control.MinimizeManager.restoreState = function () {
	/** @type {number} */
	var _minimizedState = com.inq.flash.client.control.PersistenceManager.GetValue(MINIMIZED_COUNT, com.inq.flash.client.control.MinimizeManager.NOT_MINIMIZED);
	var isInitiate = true;

	if (com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid()) {//Embedded theme chats should be restored always
		com.inq.flash.client.control.MinimizeManager.actionRestore(null, isInitiate);
	} else if (com.inq.flash.client.control.MinimizeManager.NOT_MINIMIZED != _minimizedState) {
        com.inq.flash.client.control.MinimizeManager.count = _minimizedState;/* the count is persisted in the minimized state */
        com.inq.flash.client.control.MinimizeManager.actionMinimize(null, isInitiate);
    }
    else if (com.inq.flash.client.control.PersistenceManager.GetValue(REALLY_MINIMIZED, com.inq.flash.client.control.MinimizeManager.count) == com.inq.flash.client.control.MinimizeManager.IS_MINIMIZED)
		com.inq.flash.client.control.MinimizeManager.actionReallyMinimize(null, isInitiate);/*  when a new page is visited, the minimize state should be preserved.*/
	else {
		com.inq.flash.client.control.MinimizeManager.actionRestore(null, isInitiate);
	}
};

/**
 * iPhoneSleepAwakeHandler
 *
 * RTDEV-15048
 *
 * Phone entering sleep mode or putting browser in background via home button upon awake causes chat to resume in some
 * disorganized state. The issue shows as chat window misaligned and chat input element sometimes hidden. This is
 * probably due to code in timers and callbacks not completing properly after JS thread sleeps and awakes.
 *
 * The solution uses the W3C Visibility API to detect when the page is visible or hidden. When home button pressed or
 * phone sleeps, the visibilitychange event is fired and the document.visibilityState is set to hidden. When phone
 * awakes or browse resumed (by clicking on the app) the state is set to visible.
 *
 * The approach used to return chat to sanity is to call minimize and then restore. Due to that, we need to distinguish
 * between a minimize initiated by the event handler or one initiated by user. This is so if sleep occurs when the chat
 * is already minimized, we don't restore it upon awake. com.inq.flash.client.control.MinimizeManager.minimizedBySleep
 * handles that status.
 *
 * @private
 * @this Application
 * @return {void}
 */

com.inq.flash.client.control.MinimizeManager.iPhoneSleepAwakeHandler = function (ev) {
	var restoreDelay = 1000;
	if (!com.inq.flash.client.control.MinimizeManager.isMinimized()) {
		if (window.parent.document.visibilityState === 'hidden') {
			com.inq.flash.client.control.MinimizeManager.minimizedBySleep = true;
			com.inq.flash.client.control.MinimizeManager.actionMinimize(ev,false);
		}
	} else if (com.inq.flash.client.control.MinimizeManager.minimizedBySleep && window.top.document.visibilityState === 'visible') {
		//sometimes active chat remained hidden after restore succeeded, delay resolved it
		setTimeout(
			function() {
				com.inq.flash.client.control.MinimizeManager.actionRestore(ev, false);
				com.inq.flash.client.control.MinimizeManager.minimizedBySleep = false;
			},
			restoreDelay);
	}
};

/**
 * init
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function init():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.control.MinimizeManager.init = function () {
    if (!com.inq.flash.client.control.FlashPeer.getIsSkinLocal()) {
        if (com.inq.utils.Capabilities.isPhone() && com.inq.flash.client.chatskins.SkinControl.isInApplication("smallScreenMsg")) {
            com.inq.flash.client.control.MinimizeManager.displaySmallScreenMsg();
            com.inq.flash.client.control.MinimizeManager.displaySmallScreenMsgFnPoint = com.inq.flash.client.control.MinimizeManager.displaySmallScreenMsg;
            com.inq.utils.Capabilities.BindListener(window.parent, "orientationchange", com.inq.flash.client.control.MinimizeManager.displaySmallScreenMsgFnPoint);
        }
    }
    // rtdev-14953 detect if zoomed and display message to unzoom
	if (com.inq.utils.Capabilities.isPhone() && com.inq.flash.client.chatskins.SkinControl.isInApplication("zoomedScreenMsg")) {
	  com.inq.stage.ViewportMgr.impl.toggleZoomedScreenMsg();
	}

    // RTDEV-15048 -- for iphones set handler for sleep/awake
    if (com.inq.utils.Capabilities.isIphone()){
        if (window.top.document.visibilityState) { // presence of this property means the Visibility API is available
            com.inq.utils.Capabilities.BindListener(window.top.document,"visibilitychange", com.inq.flash.client.control.MinimizeManager.iPhoneSleepAwakeHandler);
        }
    }

	com.inq.flash.client.control.MinimizeManager.onActionRestore = false; /*  RTDEV-15757*/
	com.inq.flash.client.control.MinimizeManager.count = 0;
	com.inq.flash.client.control.MinimizeManager.minimized = false;
	com.inq.flash.client.control.MinimizeManager.elMinimized = Application.application.getMxmlItem("Minimized");
	com.inq.flash.client.control.MinimizeManager.btnRestore = Application.application.getButton("btnRestore");
	com.inq.flash.client.control.MinimizeManager.btnMinimize = Application.application.getButton("btnMinimize");
	com.inq.flash.client.control.MinimizeManager.btnReallyMinimized = Application.application.getButton("btnReallyMinimized");
	com.inq.flash.client.control.MinimizeManager.agentMsgCounter = Application.application.getMxmlItem("agentMsgCounter");
	com.inq.flash.client.control.MinimizeManager.agentText = Application.application.getMxmlItem("agentText");
	com.inq.flash.client.control.MinimizeManager.ariaMegMini = Application.application.getMxmlItem("tc-aria-readme-mini");
    if (com.inq.flash.client.control.MinimizeManager.btnReallyMinimized != null && com.inq.flash.client.control.MinimizeManager.btnReallyMinimized.getStyle("floatRight") != null && com.inq.flash.client.control.MinimizeManager.btnReallyMinimized.getStyle("right") != null)
        com.inq.flash.client.control.MinimizeManager.movedMinimize = Std.parseInt(com.inq.flash.client.control.MinimizeManager.btnReallyMinimized.getStyle("floatRight")) + Std.parseInt(com.inq.flash.client.control.MinimizeManager.btnReallyMinimized.getStyle("right"));

	com.inq.flash.client.control.MinimizeManager.turnOffScaling(true);

	com.inq.flash.client.control.MinimizeManager.attachButtonHandlers();
    /* RTDEV-21737 -When a skin change happens (font button click), restoreState() should not be called as it causes
    the chat to bounce up and down. restoreState() is required when a chat is restored from minimize position*/
	if (com.inq.ui.SkinLoader.newSkinLoaded) {
        com.inq.ui.SkinLoader.newSkinLoaded = false;
	} else {
        com.inq.flash.client.control.MinimizeManager.restoreState();
		com.inq.flash.client.control.MinimizeManager.minimizeChatIfPageChanged();
    }

	com.inq.flash.client.control.MinimizeManager.initButtonVisibility();
};

/**
 * turnOffScaling - turns off scaling in mobile browsers
 * uses META tags to control the scaling option
 *
 * $type TFun([{ name => state, t => TEnum(Bool,[]), opt => true }],TEnum(Void,[]))
 * private static function turnOffScaling(?state:Bool = true)
 * @private
 * @static
 * @param {boolean}  state
 * @return {void}
 */
com.inq.flash.client.control.MinimizeManager.turnOffScaling = function(state) {
	if(state == null) state = true;
	if(com.inq.utils.Capabilities.isMobile()) try {
		/** @type {Element} */
		var tmpDiv = window.parent.document.createElement("DIV");
		tmpDiv.innerHTML = state?"<meta name=\"" + "tcChat_viewport" + "\" content=\"width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0\" />":"<meta name=\"" + "tcChat_viewport" + "\" content=\"width=device-width, initial-scale=1, maximum-scale=10.0, minimum-scale=1, user-scalable=1\" />";
	} catch( e ) {
		haxe.Log.trace("Error: " + Std.string(e),{ fileName : "MinimizeManager.hx", lineNumber : 248, className : "com.inq.flash.client.control.MinimizeManager", methodName : "turnOffScaling", customParams : [e]});
	}
};


/**
 * removeScalingMeta
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function removeScalingMeta()
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.control.MinimizeManager.removeScalingMeta = function() {
	/** @type {Element} */
	var meta = com.inq.ui.Container._getElementById("tcChat_viewport",parent.document);
	if(meta) meta.parentNode.removeChild(meta);
};


/**
 * Close
 *
 * $type TFun([],TEnum(Void,[]))
 * static public function Close():Void
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.control.MinimizeManager.Close = function() {
	var clientWin = window.parent;
	if (com.inq.flash.client.control.MinimizeManager.displaySmallScreenMsgFnPoint != null) {
		com.inq.utils.Capabilities.UnbindListener(window.parent,"orientationchange",
			com.inq.flash.client.control.MinimizeManager.displaySmallScreenMsgFnPoint);
		com.inq.flash.client.control.MinimizeManager.displaySmallScreenMsgFnPoint = null;
	}


	com.inq.utils.Capabilities.UnbindListener(window.top.document,"visibilitychange",
		com.inq.flash.client.control.MinimizeManager.iPhoneSleepAwakeHandler);


	if(!com.inq.flash.client.chatskins.SkinControl.getIsPersistentChat()) {
		/* It is important to null out the buttons
		 * Because when the chat is re initialized on the same page, we don't want the old buttons :)
		 */
		com.inq.flash.client.control.MinimizeManager.btnMinimize
			&& com.inq.flash.client.control.MinimizeManager.btnMinimize.removeEventListener(com.inq.events.MouseEvent.CLICK,
				com.inq.flash.client.control.MinimizeManager.actionMinimize);
		com.inq.flash.client.control.MinimizeManager.btnRestore
			&& com.inq.flash.client.control.MinimizeManager.btnRestore.removeEventListener(com.inq.events.MouseEvent.CLICK,
				com.inq.flash.client.control.MinimizeManager.actionRestore);
		com.inq.flash.client.control.MinimizeManager.btnReallyMinimized
			&& com.inq.flash.client.control.MinimizeManager.btnReallyMinimized.removeEventListener(com.inq.events.MouseEvent.CLICK,
				com.inq.flash.client.control.MinimizeManager.actionReallyMinimize);
		com.inq.flash.client.control.MinimizeManager.btnReallyMinimized = null;
		com.inq.flash.client.control.MinimizeManager.elMinimized = null;
		com.inq.flash.client.control.MinimizeManager.btnRestore = null;
		com.inq.flash.client.control.MinimizeManager.btnMinimize = null;
		com.inq.flash.client.control.MinimizeManager.agentMsgCounter = null;
		com.inq.flash.client.control.MinimizeManager.agentText = null;
		com.inq.flash.client.control.MinimizeManager.ariaMegMini = null;
		com.inq.flash.client.control.MinimizeManager.btnRestoreLocation = null;

		com.inq.utils.Capabilities.UnbindListener(clientWin, "scroll", com.inq.flash.client.control.MinimizeManager.floatMinimized);
		com.inq.utils.Capabilities.UnbindListener(clientWin, "resize", com.inq.flash.client.control.MinimizeManager.floatMinimized);
		com.inq.utils.Capabilities.UnbindListener(clientWin, "orientationchange", com.inq.flash.client.control.MinimizeManager.floatMinimized);
	}

	if (com.inq.utils.Capabilities.isIphone()) {
		com.inq.flash.client.control.MinimizeManager.unBindHandlerForClientInputFieldsIos();
	}
};


/**
 * Restore: public function that restores the chat to it's original size and position
 * as-of before minimization. (MOB-184)
 * Please note:
 * 1) only if minimized
 * 2) and not in persistent chat'=
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function Restore():Void
 * @public
 * @static
 * @see com.inq.flash.client.control.messagehandlers.ChatExitMessageHandler
 * @return {void}
 */
com.inq.flash.client.control.MinimizeManager.Restore = function() {
	try {
		if(com.inq.flash.client.control.MinimizeManager.minimized) com.inq.flash.client.control.MinimizeManager.actionRestore();
	} catch( e ) {
		haxe.Log.trace("Error: " + Std.string(e),{ fileName : "MinimizeManager.hx", lineNumber : 295, className : "com.inq.flash.client.control.MinimizeManager", methodName : "Restore"});
	}
};


/**
 * actionReallyMinimize
 * Similar to actionMinimize.  It hides the chat from the customer but does not show a minimized button on the page
 *
 * $type TFun([{ name => me, t => TInst(com.inq.events.MouseEvent,[]), opt => true }],TEnum(Bool,[]))
 * private static function actionReallyMinimize(?me:MouseEvent):Bool
 * @private
 * @static
 * @param {com.inq.events.MouseEvent}  me
 * @return {boolean}
 */
com.inq.flash.client.control.MinimizeManager.actionReallyMinimize = function(me) {
	if(com.inq.flash.client.control.PersistenceManager.GetValue(MESSAGE_COUNT,0) == 0) {
		com.inq.flash.client.chatskins.SkinControl.actionBtnCloseChat(null);
	}/* RTDEV-2358*/ else if(!com.inq.flash.client.chatskins.SkinControl.getIsPersistentChat()) {
		com.inq.flash.client.control.MinimizeManager.minimized = true;
		com.inq.flash.client.chatskins.SkinControl.getApplicationController().sendMinimizedMessage();
		com.inq.flash.client.control.PersistenceManager.SetValue(REALLY_MINIMIZED, com.inq.flash.client.control.MinimizeManager.IS_MINIMIZED);
		com.inq.flash.client.chatskins.SkinControl.fireCustomEvent("ChatMinimized");
		if(com.inq.ui.Stage.getInstance() != null) com.inq.ui.Stage.getInstance().setVisible(false);
	}/* RTDEV-2358*/
	return false;
};


/* Android 5.2, TalkBack doesn't support fixed position when page is scrolled down.
 To work around, a dummy restore button is added at the bottom of the page and operated as
 Restore button.
 */
com.inq.flash.client.control.MinimizeManager.talkBackDummyRestoreBtn = null;
com.inq.flash.client.control.MinimizeManager.talkBackDummyRestoreBtnAdded = null;

com.inq.flash.client.control.MinimizeManager.dummyRestoreBtn = {
	add: function() {
		try {
			var btnRestore = com.inq.ui.Container._getElementById('tcChat_btnRestore',parent.document);
			com.inq.flash.client.control.MinimizeManager.talkBackDummyRestoreBtn = btnRestore.cloneNode(true);

			var btnRestoreImg = com.inq.ui.Container._getElementById('tcChat_btnRestore_img',parent.document);
			btnRestoreImg.setAttribute('tabindex', '-1');
			btnRestoreImg.setAttribute("aria-hidden", "true");

			com.inq.flash.client.control.MinimizeManager.talkBackDummyRestoreBtn.id
				= com.inq.flash.client.control.MinimizeManager.talkBackDummyRestoreBtn.id + '_talkback';
			for (var xi = 0; xi < com.inq.flash.client.control.MinimizeManager.talkBackDummyRestoreBtn.childElementCount; xi++) {
				com.inq.flash.client.control.MinimizeManager.talkBackDummyRestoreBtn.children[xi].id
					=
					com.inq.flash.client.control.MinimizeManager.talkBackDummyRestoreBtn.children[xi].id + '_talkback'
			}
			com.inq.flash.client.control.MinimizeManager.talkBackDummyRestoreBtn.style.width = "100%";

			var btnDummyHome;
			var footers = com.inq.ui.Container._getElementByTN('footer',window.parent.document);
			if (footers.length > 0) {
				btnDummyHome = footers[0];
			}
			else {
				btnDummyHome = top.document.body;
			}

			btnDummyHome.appendChild(com.inq.flash.client.control.MinimizeManager.talkBackDummyRestoreBtn);
			com.inq.flash.client.control.MinimizeManager.talkBackDummyRestoreBtnAdded = true;
		} catch (err) {
			/* DOM exception and Cannot use support dummy Restore button. */
		}
	},
	show: function() {
		if(com.inq.flash.client.control.MinimizeManager.talkBackDummyRestoreBtn != null) {
			try {
				com.inq.flash.client.control.MinimizeManager.talkBackDummyRestoreBtn.style.display = "block";
				var btnRestoreImg = com.inq.ui.Container._getElementById('tcChat_btnRestore_img',parent.document);
				btnRestoreImg.setAttribute('tabindex', '-1');
				btnRestoreImg.setAttribute("aria-hidden", "true");
			}
			catch (err) { /* DOM exception */ }
		}
	},
	hide: function() {
		if(com.inq.flash.client.control.MinimizeManager.talkBackDummyRestoreBtn != null) {
			try {
				com.inq.flash.client.control.MinimizeManager.talkBackDummyRestoreBtn.style.display = "none";
				var btnRestoreImg = com.inq.ui.Container._getElementById('tcChat_btnRestore_img',parent.document);
				btnRestoreImg.removeAttribute('tabindex');
				btnRestoreImg.removeAttribute("aria-hidden");
			}
			catch (err) { /* DOM exception */ }
		}
	},
	remove: function() {
		if (com.inq.flash.client.control.MinimizeManager.talkBackDummyRestoreBtn != null) {
			try {
				var btnRestoreImg = com.inq.ui.Container._getElementById('tcChat_btnRestore_img',parent.document);
				btnRestoreImg.removeAttribute('tabindex');
				btnRestoreImg.removeAttribute("aria-hidden");
				com.inq.flash.client.control.MinimizeManager.talkBackDummyRestoreBtn.parentNode.removeChild(com.inq.flash.client.control.MinimizeManager.talkBackDummyRestoreBtn);
				com.inq.flash.client.control.MinimizeManager.talkBackDummyRestoreBtn = null;
				com.inq.flash.client.control.MinimizeManager.talkBackDummyRestoreBtnAdded = null;
			}
			catch (err) { /* DOM exception */ }
		}
	}
};

/**
 * actionMinimize
 * Hides the chat and displays Restore button (icon)
 *
 * @static
 * @param {com.inq.events.MouseEvent}  me
 * @return {boolean}
 */
com.inq.flash.client.control.MinimizeManager.actionMinimize = function(me, isInitiate) {

	/*  The workaround is to scroll to the bottom when we need innerWidth/Height. */
	/*  The workaround to the workaround is to scroll back to where we were while the user cannot see us doing this scrolling */
	if(!com.inq.flash.client.chatskins.SkinControl.getIsPersistentChat()) {

		if (com.inq.utils.Capabilities.isIpad() || com.inq.utils.Capabilities.isIphone()) {
			com.inq.flash.client.chatskins.SndMgr.setAriaBusy(true);
		}

		com.inq.flash.client.control.MinimizeManager.minimized = true;
		if(com.inq.utils.Capabilities.isIphone() && !(isInitiate === true) ) {
			com.inq.flash.client.chatskins.ChatTextFocusMonitor.scrollToPrevious();/* RTDEV-3840  This is a workaround for a workaround to find InnerWidth and Height on Iphones.*/
		}
		com.inq.flash.client.control.PersistenceManager.SetValue(MINIMIZED_COUNT,com.inq.flash.client.control.MinimizeManager.count);
		com.inq.flash.client.chatskins.SkinControl.fireCustomEvent("ChatMinimized");

		if (com.inq.flash.client.control.MinimizeManager.elMinimized != null) {
		    com.inq.flash.client.control.MinimizeManager.elMinimized.setVisible(true);
			/* CATO RTDEV-12602 focus moves to page and unwanted messages are read when the counter is set to visible *
			 *  @see displayAgentMessageAndCount                                                                      */
			if (com.inq.utils.Capabilities.isAndroid() && com.inq.flash.client.control.MinimizeManager.agentMsgCounter != null) {
				com.inq.flash.client.control.MinimizeManager.agentMsgCounter._div.style.opacity = 0;
				com.inq.flash.client.control.MinimizeManager.agentMsgCounter._div.style.display = "";
			}
		}
		/* Stage become hidden for non phone devices */
		if (com.inq.ui.Stage.getInstance() != null) {
			if (!com.inq.utils.Capabilities.isPhone() || isInitiate === true) {
		    com.inq.ui.Stage.getInstance().setVisible(false);
			}
		}

		if (!com.inq.utils.Capabilities.isAndroid())
		    com.inq.flash.client.control.MinimizeManager.floatMinimized(me);

		com.inq.flash.client.chatskins.SkinControl.getApplicationController().sendMinimizedMessage();

		// restore the scroll listeners RTDEV5493
		if ( !com.inq.utils.Capabilities.isPhone() ) {
			com.inq.flash.client.chatskins.ScrollMonitor.bindAll();
		}

		if (com.inq.flash.client.control.FlashPeer.getIsBuilder()) {
            //check if scrolling message disabled on Theme Editor
            if (com.inq.flash.client.control.MinimizeManager.agentText) {
                com.inq.flash.client.control.MinimizeManager.agentText._setText("is there anything else I can help you with?");
                com.inq.flash.client.control.MinimizeManager.agentText.setVisible(true);
            }
            com.inq.flash.client.control.MinimizeManager.agentMsgCounter._setText(3);
            com.inq.flash.client.control.MinimizeManager.agentMsgCounter.setVisible(true);
		}
        if(Inq["CBM"] && Inq["CBM"]["banner"] && Inq["CBM"]["banner"]["adjustRestoreDivForCobBannerRef"]) {
			try {
				Inq["CBM"]["banner"]["adjustRestoreDivForCobBannerRef"]();
			} catch (error) {
				haxe.Log.trace("Error: " + Std.string(error), { fileName: "MinimizeManager.js", lineNumber: 731, className: "com.inq.flash.client.control.MinimizeManager", methodName: "actionMinimize", customParams: [error] });
			}
		}
	}
	if(com.inq.utils.Capabilities.isIphone()) {
		com.inq.flash.client.chatskins.ChatTextFocusMonitor.blurFocusedElement();
	}

	if (com.inq.flash.client.control.MinimizeManager.btnRestore != null) {
		/**
		 * RTDEV-8129
		 *  On Android devices restore button gets focus only when restore button images is currently present in the viewport.
		 *  Based on where the restore button is currently positioned this logic determines where to scroll the page .
		 */
		if (com.inq.utils.Capabilities.isAndroid() && com.inq.utils.Capabilities.isTablet()) {
			var body = window.top.document.body;
			/**
			 * This should execute only when user zoomed in the page or page in naturally bigger than window viewport
			 */
			if (body.scrollWidth > window.top.innerWidth) {

				var minimized = Application.application.getMxmlItem("Minimized");
				var stl = minimized && minimized.styles;

				if (stl && stl["right"] && stl["bottom"]) {
					window.top.scroll(body.clientWidth - stl["right"], body.clientHeight - stl["bottom"]);
				}
				else if (stl && stl["top"] && stl["left"]) {
					window.top.scroll(0 + stl["left"], 0 + stl["top"]);
				}
			}
			/**
			 * RTDEV-15508
			 * If <isInitiate is true, the <actionMinimize> that re-display the btnRestore is invoked from
			 * restoreChat.  We need to set the <restoreChatInProgress to true so that ChatTextArea will
			 * not read the opener and transcript lines.  This variable will be reset in ChatTextArea.js.
			 */
			if (isInitiate) {
				com.inq.flash.client.control.MinimizeManager.restoreChatInProgress = true;
			}
			com.inq.utils.Timer.delay(setRestoreFocus, 500);
		} else if (com.inq.utils.Capabilities.isPhone()) {
                com.inq.flash.client.control.MinimizeManager.fixPhoneMinimizedWidth();
				if (com.inq.utils.Util.getConfig("isTalkBackDummyRestoreBtnUsed", false) == true) {
					if (com.inq.flash.client.control.MinimizeManager.talkBackDummyRestoreBtn == null) {
						com.inq.flash.client.control.MinimizeManager.dummyRestoreBtn.add();
					} else {
						com.inq.flash.client.control.MinimizeManager.dummyRestoreBtn.show();
					}

					window.setTimeout(function () {
						com.inq.flash.client.control.MinimizeManager.talkBackDummyRestoreBtn.getElementsByTagName('input')[0].focus();
						com.inq.ui.Stage.getInstance().setVisible(false);
						com.inq.flash.client.control.FlashPeer.onChatMinimize();
					}, 500);
				} else {
					/**
					 * RTDEV-15508
					 * If <isInitiate is true, the <actionMinimize> that re-display the btnRestore is invoked from
					 * restoreChat.  We need to set the <restoreChatInProgress to true so that ChatTextArea will
					 * not read the opener and transcript lines.  This variable will be reset in ChatTextArea.js.
					 */
					if (isInitiate) {
						com.inq.flash.client.control.MinimizeManager.restoreChatInProgress = true;
					}
					com.inq.utils.Timer.delay(setRestoreFocus, 700);
				}
		} else if (com.inq.utils.Capabilities.isTablet()) {
			/** RTDEV-12581
			* For tablets, set a delay before setting the focus on the restore button as this helps to deal with the CATO issue.
			*/
			com.inq.utils.Timer.delay(setRestoreFocus, 1000);
		} else {
			/** RTDEV-15351
			 * I have reverted the change of RTDEV-12581 which replaced the following statement with the
			 * com.inq.utils.Timer.delay(setRestoreFocus, 700) for both tablets and pc.  I modified so that the changes for
			 * RTDEV-12581 only apply for tablets.  I have tried to reproduce the problem with Chrome, FF 49.0.1
			 * FF 45.0.2 and FF 26.0 and only saw problem with FF 26.0 and QA reported the problem with FF 45.
			 */
			com.inq.flash.client.control.MinimizeManager.btnRestore.setImageFocus();
		}
		/**
		 * Set focus on Restore button
		 */
		function setRestoreFocus() {
			com.inq.flash.client.control.MinimizeManager.btnRestore.setImageFocus();
			if (com.inq.utils.Capabilities.isPhone()) {
				com.inq.ui.Stage.getInstance().setVisible(false);
			}
			com.inq.flash.client.control.FlashPeer.onChatMinimize();
		}
	}

	// CL-TODO RTDEV-7932 modal minimized.
	com.inq.flash.client.chatskins.SkinControl.hideModalWindow(false);

	// customer body position need to be reset
    if (com.inq.utils.Capabilities.isAndroid() && Application.savePage && Application.savePage.bodyPosition !== null) {
        top.window.document.body.style.position = Application.savePage.bodyPosition;
        Application.savePage.bodyPosition = null;
    }

	return false;
};


/**
 * actionRestore
 *
 * private static function actionRestore(?me:MouseEvent):Bool
 * @private
 * @static
 * @param {com.inq.events.MouseEvent}  evt
 * @param {boolean} isInitiate
 * @return {boolean}
 */
com.inq.flash.client.control.MinimizeManager.actionRestore = function(evt, isInitiate) {
	com.inq.flash.client.control.MinimizeManager.isChatRestored = false;
	if (!com.inq.flash.client.chatskins.SkinControl.getIsPersistentChat()) {
		if(evt)
			com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.isTouched = true;
		com.inq.flash.client.chatskins.ChatTextFocusMonitor.saveWindowPositionForce();
		com.inq.flash.client.control.MinimizeManager.count = 0;
		com.inq.flash.client.control.MinimizeManager.minimized = false;
		if (com.inq.flash.client.control.MinimizeManager.agentMsgCounter != null)
			com.inq.flash.client.control.MinimizeManager.agentMsgCounter.setVisible(false);
		if (com.inq.flash.client.control.MinimizeManager.agentText != null)
			com.inq.flash.client.control.MinimizeManager.agentText.setVisible(false);
		/**
		 * @see http://jira.touchcommerce.com/browse/RTDEV-9345
		 * @description hideModlaWindowDivs should be called only when chat is restored
		 */
		if (com.inq.flash.client.control.PersistenceManager.GetValue(MINIMIZED_COUNT, com.inq.flash.client.control.MinimizeManager.NOT_MINIMIZED)!=com.inq.flash.client.control.MinimizeManager.NOT_MINIMIZED) {
			com.inq.flash.client.chatskins.SkinControl.hideModalWindow(true);
			com.inq.flash.client.control.MinimizeManager.isChatRestored = true;
		}
		com.inq.flash.client.control.PersistenceManager.SetValue(MINIMIZED_COUNT,com.inq.flash.client.control.MinimizeManager.NOT_MINIMIZED);

		com.inq.flash.client.chatskins.SkinControl.fireCustomEvent("ChatRestored");

		if(com.inq.flash.client.control.MinimizeManager.elMinimized != null)
			com.inq.flash.client.control.MinimizeManager.elMinimized.setVisible(false);

		if (com.inq.flash.client.control.MinimizeManager.talkBackDummyRestoreBtnAdded == true) {
			com.inq.flash.client.control.MinimizeManager.dummyRestoreBtn.hide();
		}

		/*  Set state once the button has been restored. */
		if (com.inq.flash.client.control.MinimizeManager.btnReallyMinimized != null
           && com.inq.flash.client.control.PersistenceManager.GetValue(REALLY_MINIMIZED, com.inq.flash.client.control.MinimizeManager.count) == com.inq.flash.client.control.MinimizeManager.IS_MINIMIZED)
            com.inq.flash.client.control.PersistenceManager.SetValue(REALLY_MINIMIZED, com.inq.flash.client.control.MinimizeManager.SHOW_FAKE_MINIMIZE);

		if(com.inq.flash.client.chatskins.SkinControl.isInApplication("btnCloseChat")) {
			/** @type {com.inq.ui.Button} */
			var btnClose = Application.application.getButton("btnCloseChat");
			btnClose.setVisible(true);
		}/*  make the close button visible as well*//*  make the close button visible as well*/

		if (com.inq.flash.client.control.MinimizeManager.btnReallyMinimized != null
			&& com.inq.flash.client.control.MinimizeManager.btnReallyMinimized.getStyle("neverShow") == "false"
			&& com.inq.flash.client.control.PersistenceManager.GetValue(REALLY_MINIMIZED, com.inq.flash.client.control.MinimizeManager.count) == com.inq.flash.client.control.MinimizeManager.SHOW_FAKE_MINIMIZE) {
			com.inq.flash.client.control.MinimizeManager.btnReallyMinimized.setStyle("right",com.inq.flash.client.control.MinimizeManager.movedMinimize + "px");
        }
        else if (com.inq.flash.client.control.MinimizeManager.btnReallyMinimized != null
				&& com.inq.flash.client.control.MinimizeManager.btnReallyMinimized.getStyle("neverShow") == "true"
				&& com.inq.flash.client.control.PersistenceManager.GetValue(REALLY_MINIMIZED, com.inq.flash.client.control.MinimizeManager.count) == com.inq.flash.client.control.MinimizeManager.SHOW_FAKE_MINIMIZE) {
			com.inq.flash.client.control.MinimizeManager.btnReallyMinimized.setVisible(false);
        }


		if (com.inq.ui.Stage.getInstance() != null) {
			com.inq.flash.client.chatskins.ScrollMonitor.moveChat();		/* This must be sent to position correctly after minimize */
			com.inq.ui.Container.show("chat");
			com.inq.ui.Stage.getInstance().setVisible(true);
			Application.application.setVisible(true);
		}

		if (com.inq.utils.Capabilities.isPhone() && !com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid()) {
			Application.SetArea(com.inq.utils.Capabilities.getViewport());
			com.inq.stage.ViewportMgr.uponResize();
		} else {
			/**
			 * http://jira.touchcommerce.com/browse/RTDEV-8942
			 * although we set the stage visibility browser reflow and repaint did not happen by the time Appliation.Resize is called.
			 * Due to that parentNode clientWidth value is 0. By yielding the UI thread to browser we are able to get the client width
			 */
			var skin = com.inq.ui.Container._getElementById(com.inq.ui.Container.SC_SKIN,parent.document);
			if(skin && skin.clientWidth===0) {
				var timer = new com.inq.utils.Timer(25);
				timer.run = function()
				{
					if(skin.clientWidth!==0) {
						Application.Resize();
						timer.stop();
					}
				}
			} else {
				Application.Resize();
			}
        }


		/* RTDEV-3802 was caused by timing issue.
		 * If User was typing and had virtual keyboard mode when he/she hide(minimize) a chat
		 * the chat's window size was about a half of device window size before and while it was minimized
		 * Transcripts should scrolled after the chat area is readjusted to full device window size.
		 */
		if (com.inq.ui.Stage.getInstance() != null) {
			com.inq.flash.client.chatskins.SkinControl.scrollTranscriptToEnd();
        }

		if (com.inq.flash.client.control.MinimizeManager.displaySmallScreenMsgFnPoint != null) {
			com.inq.flash.client.control.MinimizeManager.displaySmallScreenMsg();
        }

        // rtdev-14953 when restored, check if screen is zoomed to display message
		if (com.inq.utils.Capabilities.isPhone() && com.inq.flash.client.chatskins.SkinControl.isInApplication("zoomedScreenMsg")) {
	      com.inq.stage.ViewportMgr.impl.toggleZoomedScreenMsg();
	    }

		if (com.inq.flash.client.control.MinimizeManager.isChatRestored) {
			com.inq.flash.client.chatskins.SkinControl.getApplicationController().sendRestoredMessage();
		}

	    //RTDEV 5493 - check chat position possibly user scrolled while minimize
		com.inq.flash.client.chatskins.ScrollMonitor.moveChat();
	}

	// To Support Talkback on Android
	if (com.inq.utils.Util.getConfigAsBoolean("enableModal") && com.inq.utils.Capabilities.isAndroid() && com.inq.utils.Capabilities.isPhone()) {
		if (Application.savePage.bodyPosition === null) {
			Application.savePage.bodyPosition = top.window.document.body.style.position;
		}
		// Android CATO is broken if body jumps around
		top.window.document.body.style.position = 'fixed';
	}

	com.inq.flash.client.control.MinimizeManager.restoreFocusedElement(evt, isInitiate, com.inq.flash.client.control.MinimizeManager.isChatRestored);
	com.inq.flash.client.control.FlashPeer.applyAcifCommands();

	/*
		We need this line to make JAWS read last message after
		the chat restoring.
		JAWS 2018.1808.10 doesn't read text of element with aria-live="assertive"
		attribute if the new text value of element is the same as previous.
	 */
	com.inq.aria.AriaMsg.clearAriaMsg();

	return false;
};

/**
 * This function calls actionMinimize() if customer go to another page,
 * or client was redirected to another page by agent.
 * Logic of this function based on window.parent.document.referrer.
 */
com.inq.flash.client.control.MinimizeManager.minimizeChatIfPageChanged = function () {
	try {
		if (com.inq.utils.Util.getParentReferrer()
			&& com.inq.utils.Capabilities.isPhone()
			&& com.inq.utils.Util.getNavigationType() !== 1
			&& !com.inq.flash.client.control.MinimizeManager.isChatRestored
			&& !com.inq.flash.client.control.FlashPeer.isEmbeddedThemeValid()
			&& !com.inq.flash.client.control.FlashPeer.isCEAPIPostChatSurveyMode()
			&& com.inq.flash.client.control.PersistenceManager.GetValue(CHAT_ENGAGED, false)
		) {

			/* RTDEV-20425/20557: Mobile Inline Authentication - Chat minimizes after login complete.
			 * When a inline form (with in chat) is submitted, the url (location.href) remains the same
			 * but performance.navigation.type is still 0. We can handle such situation by comparing
			 * the previous url. If the urls match, then the chat should not be minimized.
			 * Also it need not be minimized if previous url is null/empty.
			*/
			var previousUrl = new URL(com.inq.utils.Util.getParentReferrer());
			var prvUrl = previousUrl.host + previousUrl.pathname;
			var parentLocation = com.inq.utils.Util.getParentLocation();
			var currUrl = parentLocation.host + parentLocation.pathname;
			if (prvUrl !== currUrl) {
				com.inq.utils.Timer.delay(function () {
					com.inq.flash.client.control.MinimizeManager.actionMinimize();
				}, 100);
			}
		}
	} catch(ex) {
		// This try-catch block added to avoid any issues in this function
		// In case when something went wrong chat wouldn't be minimized.
	}
};

/**
 * Sets the focus onto appropriate element after restore the chat from minimized state.
 * @param {com.inq.events.MouseEvent} evt
 * @param {boolean} isInitiate
 * @param {boolean} isChatRestored
 * @return {void}
 */
com.inq.flash.client.control.MinimizeManager.restoreFocusedElement = function(evt, isInitiate, isChatRestored) {
	var txtInput = com.inq.flash.client.chatskins.SkinControl.getTextInputField();
	if (txtInput != null && !com.inq.flash.client.chatskins.SkinControl.agentClosedChat && !Application.setFocusToBtnCloseOnOpen) {
		if (com.inq.utils.Capabilities.isMobile()) {
			if (com.inq.flash.client.control.WebRTCMgr && com.inq.flash.client.control.WebRTCMgr.isCallStarted()) {
				var muteBtn = com.inq.flash.client.control.WebRTCMgr.getMuteBtn();
				muteBtn.setImageFocus();
			} else if (!com.inq.flash.client.chatskins.SkinControl.hideObscuredChatDiv(isChatRestored, txtInput)) {
				if (com.inq.utils.Capabilities.isIpad() && com.inq.flash.client.chatskins.SkinControl.accessibilityHelp.isAccessibilityHelpUsed) {
					/**
					 * @see https://jira.touchcommerce.com/browse/RTDEV-26287
					 *  Check if modal window is enabled, because it adds new features that work with the 'aria-hidden' attribute
					 *  to change the navigation to the DOM elements on a page, and because of this the normal operation of the screen reader(Voice Over) application is interrupted on IPad.
					 *  To fix this issue, we added setTimeout, which sets the focus only after changing the 'aria-hidden' attribute on the page elements and gives time to re-render the page.
					 *
					 *  In the future, we plan to replace the use of the 'aria-hidden' attribute of the 'aria-modal' attribute.
					 *  That will change implementation to build modal window and do this more accessible for people with disabilities.
					 */
					if (com.inq.utils.Util.getConfigAsBoolean("enableModal")) {
						setTimeout(function() {
							txtInput.setFocus();
						}, 500);
					} else {
						txtInput.setFocus();
					}
				} else if (com.inq.utils.Capabilities.isIphone() ){
					/*RTDEV-16769: When chat is restored back using the function iPhoneSleepAwakeHandler(), there is no touch event involved
					 * and therefore when the txtInput.setFocus(true) is called in the below code, only the the chat window resizes but the
					  * keyboard does not show up (exposing the underneath client page). Keyboard will show up only when there is a touch event
					  * involved (iphone security thing). Hence we will not call the txtInput.setFocus(true) method when actionRestore() is
					  * called through iPhoneSleepAwakeHandler()
					 */
					if(!com.inq.flash.client.control.MinimizeManager.minimizedBySleep) {
						if (com.inq.flash.client.chatskins.SkinControl.accessibilityHelp.isAccessibilityHelpUsed) {
							txtInput.setVisible(false);
							txtInput.setVisible(true);
							com.inq.aria.AriaMsg.clearAriaMsg();
							if (com.inq.flash.client.control.MinimizeManager.ariaMegMini) {
								com.inq.flash.client.control.MinimizeManager.ariaMegMini._div.innerHTML = "";
							}
							/**
							 * @see http://jira.touchcommerce.com/browse/RTDEV-14510
							 *  Bug: On chat restore, the keyboard comes up but the chat does not resize to show the input textarea
							 *  Fix: In iPhones, the setFocus() triggers Focus Monitors and Scroll Monitors. The Scroll Monitors have methods (e.g whenPhoneScroll()) which
							 *  check if the focus (com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.HasFocus) is set to true and resizes the chat window
							 *  based on this check.
							 *  This logic works fine when the chat window is open and when the user touches the input textarea, it fires the onfocus event which
							 *  calls the method onFocus() to set the "com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.HasFocus" to true and brings up
							 *  the soft keyboard.                         *
							 *  However, this does not work when the chat is restored because there is no call to onFocus() method. So even if we explicitly call the onFocus()
							 *  during restore, "com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.HasFocus" will be set to false by the event
							 *  "onBlurHandlerPhoneIphone()". We cannot predict when this onBlurHandlerPhoneIphone() will be executed because it is fired through a setTimeout.
							 *
							 *  To handle the above problem, a new variable onActionRestore is introduced which is set to true before the setFocus() call and then later set to false.
							 *  In the method whenPhoneScroll() of the scroll monitor, we will look for the variable onActionRestore and then set the
							 *  "com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.prototype.HasFocus" to true.
							 *
							 *  ScrollTo(0, -1) is called so that if the client window is not showing the address bar, then this scrollTo will bring it back. Refer to
							 *  https://jira.touchcommerce.com/browse/RTDEV-14784 for more info
							 */
							com.inq.flash.client.chatskins.ScrollMonitor.ScrollTo(0, -1);
							focusAndTimeout();
						} else if (isChatRestored && evt) {
							focusAndTimeout();
						} else if(!com.inq.flash.client.chatskins.SkinControl.accessibilityHelp.isAddHelpOnBtnSendCalled && !com.inq.flash.client.chatskins.SkinControl.initialFocusClaimedBy) {
							window.parent.document.activeElement.blur();
						}
					}

				} else if(isChatRestored || com.inq.utils.Capabilities.isIpad()){
					txtInput.setFocus();
				} else {
					com.inq.flash.client.chatskins.SkinControl.setUpFocusAndSelection(isInitiate);
				}
			} else {
				com.inq.flash.client.chatskins.SkinControl.setUpFocusAndSelection(isInitiate);
			}
		} else if (com.inq.flash.client.chatskins.SkinControl.getIsPersistentChat() && com.inq.utils.Capabilities.getIeVersion() === 8) {
			window.setTimeout(function() {
				window.document.body.focus();
				window.setTimeout(function(){
					txtInput.setFocus();
				})
			}, 500)
		} else {
			com.inq.flash.client.chatskins.SkinControl.setUpFocusAndSelection(isInitiate);
		}
	}

	if (Application.setFocusToBtnCloseOnOpen) {
		com.inq.flash.client.chatskins.SkinControl.setFocusOnCloseButton();
	}

	function focusAndTimeout() {
		if (!Application.setFocusToBtnCloseOnOpen) {
			com.inq.flash.client.control.MinimizeManager.onActionRestore = true;
			txtInput.setFocus(true);
			window.setTimeout(function () {
				com.inq.flash.client.control.MinimizeManager.onActionRestore = false;
			}, 1000);
		}
	}
};


/**
 * return true if minimize is true or chat was minimized in previous page.
 *
 * @public
 * @static
 * @return {boolean}
 */
com.inq.flash.client.control.MinimizeManager.isMinimized = function() {
	return com.inq.flash.client.control.MinimizeManager.minimized === true
		   || com.inq.flash.client.control.PersistenceManager.GetValue(MINIMIZED_COUNT, com.inq.flash.client.control.MinimizeManager.NOT_MINIMIZED) !== com.inq.flash.client.control.MinimizeManager.NOT_MINIMIZED ;
};


/**
 * floatMinimized
 * Ensure that the "minimized" chat button remains in the viewport.
 *
 * We will get the left, right, top, bottom, width, height from the MXML description
 * We will only position if we are mobile.
 *
 * $type TFun([{ name => e, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * private static function floatMinimized(e:Dynamic):Bool
 * @private
 * @static
 * @param {null}  e
 * @return {boolean}
 */
com.inq.flash.client.control.MinimizeManager.floatMinimized = function(e) {

	if (com.inq.flash.client.control.MinimizeManager.isMinimized() && com.inq.utils.Capabilities.isMobile()
		&& com.inq.flash.client.control.MinimizeManager.elMinimized != null) {
		if ((com.inq.utils.Capabilities.isSafariVersion9()
			|| com.inq.utils.Capabilities.isSafariVersion10()
			|| com.inq.utils.Capabilities.isSafariVersion11()
			|| com.inq.utils.Capabilities.isSafariVersion12()
			|| com.inq.utils.Capabilities.isSafariVersion13()
			|| com.inq.utils.Capabilities.isSafariVersion14orLater()
			|| com.inq.utils.Capabilities.isChromeiOS()
			|| com.inq.utils.Capabilities.isIpad())
			&& com.inq.flash.client.control.MinimizeManager.elMinimized.getStyle('position') == "fixed") {
			e && e.stopPropagation && e.stopPropagation();
			return false;
		}
		if (com.inq.flash.client.control.MinimizeManager.elMinimized._div != null) {
			/** @type {?string} */
			var left = null;
			/** @type {?string} */
			var right = null;
			/** @type {?string} */
			var top = null;
			/** @type {?string} */
			var bottom = null;
			/** @type {?string} */
			var height = null;
			/** @type {?string} */
			var width = null;
			/** @type {number} */
			var l = 0;
			/** @type {number} */
			var t = 0;
			/** @type {number} */
			var h;
			/** @type {number} */
			var w;

			/* Gather the location information from the original MXML settings */

			left = com.inq.flash.client.control.MinimizeManager.elMinimized.getStyle("left");
			right = com.inq.flash.client.control.MinimizeManager.elMinimized.getStyle("right");
			top = com.inq.flash.client.control.MinimizeManager.elMinimized.getStyle("top");
			bottom = com.inq.flash.client.control.MinimizeManager.elMinimized.getStyle("bottom");
			height = com.inq.flash.client.control.MinimizeManager.elMinimized.getStyle("height");
			width = com.inq.flash.client.control.MinimizeManager.elMinimized.getStyle("width");

			/* Get the view port from Capabilities */
			/** @type {com.inq.utils.Area} */
			var vp = com.inq.utils.Capabilities.getViewport();

			/* We need the width and height (w and h) to position the bottom as top or the right as left
			 * Huh? WTH does that mean, well we want to make it relative to left of the view port and
			 * down from the top.
			 * In other words, we translate bottom to top, and right to left with some math :)
			 */
			w = width == null ? com.inq.flash.client.control.MinimizeManager.elMinimized.getWidth()
				: com.inq.flash.client.control.MinimizeManager.elMinimized.evaluatePosition(width);
			h = height == null ? com.inq.flash.client.control.MinimizeManager.elMinimized.getHeight()
				: com.inq.flash.client.control.MinimizeManager.elMinimized.evaluatePosition(height);

			/* Fix right and left
			 * Left is offset by the viewport left
			 * Right is offset by the viewport width and the item width
			 */
			if (left == null && right != null) {
				l = vp.x + vp.w - w - com.inq.flash.client.control.MinimizeManager.elMinimized.evaluatePosition(right);
			} else if (left != null && right == null) {
				l = vp.x + com.inq.flash.client.control.MinimizeManager.elMinimized.evaluatePosition(left);
			}

			/* Fix the bottom and top
			 * Top is offset by the viewport top
			 * Bottom is offset by the viewport top and viewport height and item height
			 */
			if (top == null && bottom != null) {
				t = vp.y + vp.h - h - com.inq.flash.client.control.MinimizeManager.elMinimized.evaluatePosition(bottom);
			} else if (left != null && right == null) {
				t = vp.y + com.inq.flash.client.control.MinimizeManager.elMinimized.evaluatePosition(top);
			}

			/* Position the restore button absolutely */
			/** @type {Element} */
			var divRestore = com.inq.flash.client.control.MinimizeManager.elMinimized._div;
			divRestore.style.position = "absolute";
			divRestore.style.left = l + "px";
			divRestore.style.top = t + "px";
			/** since we are setting left with pixel and width value above.setting right to auto because right has higher priority than left*/
			if(width)
				divRestore.style.right = "auto";
			/**
			 * @see http://jira.touchcommerce.com/browse/RTDEV-10227
			 * @description when the above logic did not set any value to the top position of Minimized button and btnRestore has position fixed set, iam letting
			 * the browser to handle the positioning.
			 */
			if (com.inq.flash.client.control.MinimizeManager.btnRestore
				&& com.inq.flash.client.control.MinimizeManager.btnRestore.styles.position == "fixed" && t==0) {
				e && e.stopPropagation && e.stopPropagation();
				return false;
			}
			return true;
		} else haxe.Log.trace("ERROR: elMinimized._div is null",{ fileName : "MinimizeManager.hx", lineNumber : 458, className : "com.inq.flash.client.control.MinimizeManager", methodName : "floatMinimized"});
	}
	return false;
};




/**
* iosPositionMinimize - positions the minimize button above the keyboard on iphone
* $type TFun([],TEnum(Void,[]))
* static private function iosPositionMinimized():Bool
* @public
* @static
* @return {boolean}
*/
com.inq.flash.client.control.MinimizeManager.iosPositionMinimized = function () {
    try {
	    /** @type {?HTMLElement} */
	    var divRestore = null;
	    /** @type {number} */
	    var clientLayoutHeight = 0;
	    /** @type {number} */
	    var minimizeButtonHeight = 0;
	    /** @type {?string} */
	    var orientation = null;
	    /** @type {number} */
	    var keyboardHeight = 0;
	    /** @type {number} */
	    var top = 0;

        divRestore = com.inq.ui.Container._getElementById("tcChat_Minimized",parent.document);//com.inq.flash.client.control.MinimizeManager.elMinimized._div;
        clientLayoutHeight = window.top.document.documentElement.clientHeight;
        if(com.inq.utils.Capabilities.isChromeiOS()){
            clientLayoutHeight = clientLayoutHeight - com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneCRiOS10.CHROME_IOS_HEIGHT_DIFF;
        }
        var minimizeBackingObject = Application.application.getMxmlItem("Minimized");
        if (minimizeBackingObject) {
            minimizeButtonHeight = minimizeBackingObject.getHeight();
        }
		if(com.inq.utils.Capabilities.isIOSWebView() && divRestore){
			com.inq.flash.client.control.MinimizeManager.iosPositionWebViewMinimized(divRestore,minimizeButtonHeight);
			return;
		}
	    /** @type {boolean} */
	    var portrait = com.inq.utils.Capabilities.getOrientation();
	    orientation = portrait ? "portrait" : "landscape";

        switch (orientation) {
            case "landscape":
                keyboardHeight = com.inq.flash.client.control.MinimizeManager.SAFARI_KEYBOARD_HEIGHT_LANDSCAPE;
                top = (clientLayoutHeight - keyboardHeight) / 2;// center of remaining screen area
                top = top + window.top.pageYOffset;  // the logic for portrait does not work in landscape - presumably because of built in iOS behaviour to center
                // the input box -  positioning the button in the center of the remaining screen area plus the
                // scroll Y seems to land it just about correctly above the keyboard.
                break;
            case "portrait":
                keyboardHeight = com.inq.flash.client.control.MinimizeManager.SAFARI_KEYBOARD_HEIGHT_PORTRAIT;
                top = clientLayoutHeight - (keyboardHeight + minimizeButtonHeight);
                top = top +  window.top.pageYOffset;
                break;
        }

        if (divRestore) {
            divRestore.style.position = "fixed";
            divRestore.style.top = top + "px";
            divRestore.style.left = window.top.pageXOffset + "px";
        }
        else
            haxe.Log.trace("Error: geting minimize div", { fileName: "MinimizeManager.js", lineNumber: 675, className: "com.inq.flash.client.control.MinimizeManager", methodName: "positionMinimize" });
    }
    catch (error) {
        haxe.Log.trace("Error: " + Std.string(error), { fileName: "MinimizeManager.js", lineNumber: 678, className: "com.inq.flash.client.control.MinimizeManager", methodName: "positionMinimize", customParams: [error] });
    }
    return true;
};
/**
 *  webview will have correct window.top.innerHeight when virtual keyboard is visible
 * @param restoreBtn {HTMLElement}
 * @param restoreBtnHeight {number}
 */
com.inq.flash.client.control.MinimizeManager.iosPositionWebViewMinimized = function(restoreBtn,restoreBtnHeight){
	restoreBtn.style.position = "absolute";
	restoreBtn.style.top = window.top.pageYOffset+(window.top.innerHeight-restoreBtnHeight) + "px";
	restoreBtn.style.left = window.top.pageXOffset + "px";
};
/**
 * When ever minimized button width is bigger that the phone screen width, adjust its width to screen width
 * @see RTDEV-13250
 */
com.inq.flash.client.control.MinimizeManager.fixPhoneMinimizedWidth = function(){
    var minimizedEl = Application.application.getMxmlItem("Minimized") && Application.application.getMxmlItem("Minimized")._div;
    var winWidth = window.top.innerWidth;
    if(minimizedEl && minimizedEl.clientWidth>winWidth) {
        minimizedEl.style.width = winWidth+'px';
    }
};

/**
* iosClientInputFocus - handler for iphone focus on input - attaches scroll handler since iphone will scroll the page to put the input in the center- client page only( as opposed to chatTextArea)
* $type TFun([],TEnum(Void,[]))
* static private function iosClientInputFocus():Void
* @private
* @return {void}
*/
com.inq.flash.client.control.MinimizeManager.iosClientInputFocus = function (e) {
	/** @type {Window}*/
	var clientWin = window.parent;
	// remove handlers to position button during user scrollbar scroll
	com.inq.utils.Capabilities.UnbindListener(clientWin, "scroll", com.inq.flash.client.control.MinimizeManager.floatMinimized);
	com.inq.utils.Capabilities.UnbindListener(clientWin, "resize", com.inq.flash.client.control.MinimizeManager.floatMinimized);
	com.inq.utils.Capabilities.UnbindListener(clientWin, "orientationchange", com.inq.flash.client.control.MinimizeManager.floatMinimized);
	com.inq.flash.client.chatskins.ScrollMonitor.unbindAll();

	// just in time event handlers.... to handle built in iOS resizing and scrolling of input fields
	// add jit event handler to position button during client page - iphone default input scroll
	window.top.addEventListener("scroll", com.inq.flash.client.control.MinimizeManager.iosPositionMinimized, false);
	window.top.addEventListener("orientationchange", com.inq.flash.client.control.MinimizeManager.iosPositionMinimized, false);//RTDEV-19628: when the
	/*RTDEV-19628: call the function directly without any listener for ios11 because the input focus does not fire a scroll event in iOS11 unlike iOS10*/
	if (com.inq.utils.Capabilities.isIOSWebView()
		|| com.inq.utils.Capabilities.isSafariVersion11() || com.inq.utils.Capabilities.isChromeiOS11()
		|| com.inq.utils.Capabilities.isSafariVersion12() || com.inq.utils.Capabilities.isChromeiOS12()
		|| com.inq.utils.Capabilities.isSafariVersion13() || com.inq.utils.Capabilities.isChromeiOS13()
		|| com.inq.utils.Capabilities.isSafariVersion14orLater() || com.inq.utils.Capabilities.isChromeiOS14()
	) {
		com.inq.flash.client.control.MinimizeManager.iosPositionMinimized();
	}
};
/**
* iosClientInputBlur - handler for iphone loose focus on input - removes just in time scroll handler, re-attaches floatMinimize
* $type TFun([],TEnum(Void,[]))
* static private function iosClientInputBlur():Void
* @private
* @return {void}
*/
com.inq.flash.client.control.MinimizeManager.iosClientInputBlur = function (e) {
    // remove just in time event handlers to handle built in iOS resizing and scrolling of input fields
    window.top.removeEventListener("scroll", com.inq.flash.client.control.MinimizeManager.iosPositionMinimized, false);

	window.top.removeEventListener("orientationchange", com.inq.flash.client.control.MinimizeManager.iosPositionMinimized, false);

	/**
	 * Set the Restore button's location and size back to the focus event
	 * This change is only needed for iOS 9
	 * @see com.inq.flash.client.control.MinimizeManager.floatMinimized
	 */
	if (com.inq.utils.Capabilities.isSafariVersion9()
		|| com.inq.utils.Capabilities.isSafariVersion10()
		|| com.inq.utils.Capabilities.isSafariVersion11()
		|| com.inq.utils.Capabilities.isSafariVersion12()
		|| com.inq.utils.Capabilities.isSafariVersion13()
		|| com.inq.utils.Capabilities.isSafariVersion14orLater()
	) {
		var divRestore = com.inq.ui.Container._getElementById("tcChat_Minimized", parent.document);
		divRestore.style.position = com.inq.flash.client.control.MinimizeManager.btnRestoreLocation.position;
		divRestore.style.left = com.inq.flash.client.control.MinimizeManager.btnRestoreLocation.left;
		divRestore.style.top = com.inq.flash.client.control.MinimizeManager.btnRestoreLocation.top;
	} else {
		com.inq.flash.client.control.MinimizeManager.floatMinimized();
	}
	/** @type {Window} */
	var clientWin = window.parent;
    com.inq.utils.Capabilities.BindListener(clientWin, "scroll", com.inq.flash.client.control.MinimizeManager.floatMinimized);
    com.inq.utils.Capabilities.BindListener(clientWin, "resize", com.inq.flash.client.control.MinimizeManager.floatMinimized);
    com.inq.utils.Capabilities.BindListener(clientWin, "orientationchange", com.inq.flash.client.control.MinimizeManager.floatMinimized);

    com.inq.flash.client.chatskins.ScrollMonitor.bindAll();
};



/**
* bindHandlerForClientInputFieldsIos - handlers to reposition the minimize button when keyboard is triggered by focus on input field on client page
* $type TFun([],TEnum(Void,[]))
* private function bindHandlerForClientInputFieldsIos():Void
* @private
* @return {void}
*/
com.inq.flash.client.control.MinimizeManager.bindHandlerForClientInputFieldsIos = function () {
	/**
	 * Save Current Location and Size of Restore button
	 * @see com.inq.flash.client.control.MinimizeManager.floatMinimized
	 */
	if (com.inq.utils.Capabilities.isSafariVersion9()
		|| com.inq.utils.Capabilities.isSafariVersion10()
		|| com.inq.utils.Capabilities.isSafariVersion11()
		|| com.inq.utils.Capabilities.isSafariVersion12()
		|| com.inq.utils.Capabilities.isSafariVersion13()
		|| com.inq.utils.Capabilities.isSafariVersion14orLater()
	) {
		var divRestore = com.inq.ui.Container._getElementById("tcChat_Minimized", parent.document);
		com.inq.flash.client.control.MinimizeManager.btnRestoreLocation = {
			position: divRestore.style.position,
			left: divRestore.style.left,
			top: divRestore.style.top
		};
	}

    var inputs = com.inq.ui.Container._getElementByTN("input",window.parent.document);
    for (var i = 0; i < inputs.length; i++) {
        if ((inputs[i].className.indexOf("tcChat") == -1) && (inputs[i].className.indexOf("tcXF") == -1) && inputs[i].readOnly !== true ) {
            inputs[i].addEventListener("focus", com.inq.flash.client.control.MinimizeManager.iosClientInputFocus, false);
            inputs[i].addEventListener("blur", com.inq.flash.client.control.MinimizeManager.iosClientInputBlur, false);
        }
    }

    var selects = com.inq.ui.Container._getElementByTN("select",window.parent.document);
    for (var i = 0; i < selects.length; i++) {
        if ((selects[i].className.indexOf("tcChat") == -1) && (selects[i].className.indexOf("tcXF") == -1)) {
            selects[i].addEventListener("focus", com.inq.flash.client.control.MinimizeManager.iosClientInputFocus, false);
            selects[i].addEventListener("blur", com.inq.flash.client.control.MinimizeManager.iosClientInputBlur, false);
        }
    }

    var textareas = com.inq.ui.Container._getElementByTN("textarea",window.parent.document);
    for (var i = 0; i < textareas.length; i++) {
        if ((textareas[i].className.indexOf("tcChat") == -1) && (textareas[i].className.indexOf("tcXF") == -1)) {
            textareas[i].addEventListener("focus", com.inq.flash.client.control.MinimizeManager.iosClientInputFocus, false);
            textareas[i].addEventListener("blur", com.inq.flash.client.control.MinimizeManager.iosClientInputBlur, false);
        }
    }
};

com.inq.flash.client.control.MinimizeManager.unBindHandlerForClientInputFieldsIos = function () {
	var inputs = com.inq.ui.Container._getElementByTN("input",window.parent.document);
	for (var i = 0; i < inputs.length; i++) {
		if ((inputs[i].className.indexOf("tcChat") == -1) && (inputs[i].className.indexOf("tcXF") == -1) && inputs[i].readOnly !== true ) {
			inputs[i].removeEventListener("focus", com.inq.flash.client.control.MinimizeManager.iosClientInputFocus, false);
			inputs[i].removeEventListener("blur", com.inq.flash.client.control.MinimizeManager.iosClientInputBlur, false);
		}
	}

	var selects = com.inq.ui.Container._getElementByTN("select",window.parent.document);
	for (var i = 0; i < selects.length; i++) {
		if ((selects[i].className.indexOf("tcChat") == -1) && (selects[i].className.indexOf("tcXF") == -1)) {
			selects[i].removeEventListener("focus", com.inq.flash.client.control.MinimizeManager.iosClientInputFocus, false);
			selects[i].removeEventListener("blur", com.inq.flash.client.control.MinimizeManager.iosClientInputBlur, false);
		}
	}

	var textareas = com.inq.ui.Container._getElementByTN("textarea",window.parent.document);
	for (var i = 0; i < textareas.length; i++) {
		if ((textareas[i].className.indexOf("tcChat") == -1) && (textareas[i].className.indexOf("tcXF") == -1)) {
			textareas[i].removeEventListener("focus", com.inq.flash.client.control.MinimizeManager.iosClientInputFocus, false);
			textareas[i].removeEventListener("blur", com.inq.flash.client.control.MinimizeManager.iosClientInputBlur, false);
		}
	}
};

/** @private @type {com.inq.ui.Html} */
com.inq.flash.client.control.MinimizeManager.agentMsgCounter = null;

/** @private @type {com.inq.ui.Html} */
com.inq.flash.client.control.MinimizeManager.agentText = null;

/** @private @type {com.inq.ui.Button} */
com.inq.flash.client.control.MinimizeManager.btnRestore = null;

/** @private @type {com.inq.ui.Button} */
com.inq.flash.client.control.MinimizeManager.btnMinimize = null;

/** @private @type {com.inq.ui.Button} */
com.inq.flash.client.control.MinimizeManager.btnReallyMinimized = null;

/** @private @type {number} */
com.inq.flash.client.control.MinimizeManager.IS_MINIMIZED = -1;

/** @private @type {number} */
com.inq.flash.client.control.MinimizeManager.SHOW_FAKE_MINIMIZE = -2;

/** @private @type {com.inq.ui.Html} */
com.inq.flash.client.control.MinimizeManager.elMinimized = null;

/** @private @type {com.inq.utils.Point} */
com.inq.flash.client.control.MinimizeManager._minimizedOffset = null;

/** @private @type {com.inq.ui.Html} */
com.inq.flash.client.control.MinimizeManager.inqChatStage = null;

/** @private @type {string} */
com.inq.flash.client.control.MinimizeManager.originalScalingMeta = null;

/** @private @type {number} */
com.inq.flash.client.control.MinimizeManager.NOT_MINIMIZED = -1;

/** @private @type {string} */
com.inq.flash.client.control.MinimizeManager.META_ID = "tcChat_viewport";

/** @private @type {string} */
com.inq.flash.client.control.MinimizeManager.SCALING_META = "<meta name=\"" + "tcChat_viewport" + "\" content=\"width=device-width, initial-scale=1, maximum-scale=10.0, minimum-scale=1, user-scalable=1\" />";

/** @private @type {string} */
com.inq.flash.client.control.MinimizeManager.NO_SCALING_META = "<meta name=\"" + "tcChat_viewport" + "\" content=\"width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=0\" />";

/** @private @type {number} */
com.inq.flash.client.control.MinimizeManager.movedMinimize = 0;

/** @private @type {null} */
com.inq.flash.client.control.MinimizeManager.displaySmallScreenMsgFnPoint = null;

/** @type {number} */
com.inq.flash.client.control.MinimizeManager.MODE_FIXED = 0;
/** @type {number} */
com.inq.flash.client.control.MinimizeManager.MODE_ABSOLUTE = 1;
/** @type {number} */
com.inq.flash.client.control.MinimizeManager.positionMode = null;
/** @type {com.inq.utils.Point} */
com.inq.flash.client.control.MinimizeManager.touchStartPoint = null;
/*
the safari magic keyboard numbers are read by iosPositionMinimize which positions the mimize button above the keyboard
on iphone - aka MOB-519 - iosPositionMinimize is called by the just in time scroll handler iosClientInputFocus
https://developer.apple.com/library/mac/documentation/AppleApplications/Reference/SafariWebContent/DesigningForms/DesigningForms.html
*/
/** @public @type {number} */
com.inq.flash.client.control.MinimizeManager.SAFARI_KEYBOARD_HEIGHT_PORTRAIT = 216;
/** @public @type {number} */
com.inq.flash.client.control.MinimizeManager.SAFARI_KEYBOARD_HEIGHT_LANDSCAPE = 162;

/** @public @type {boolean} */
com.inq.flash.client.control.MinimizeManager.isChatRestored = false;
